export default __webpack_public_path__ + "static/media/error302ART.2502317b.png";